export default __webpack_public_path__ + "static/media/GitHubLogo.255db585.svg";